import { takeEvery } from 'redux-saga'
import { put, select, call } from 'redux-saga/effects'
import { destroyCameraSelector } from 'selectors'
import { DESTROY_CAMERA, removeCameraAction } from 'actions/cameraActions'
import { updatePresentationValuesAction } from 'actions/presentationActions'
import { removeDeviceWiresAction } from 'actions/entityActions'
import findById from 'helpers/findById'
import chooseProperCameraToShift from 'helpers/cameras/chooseProperCameraToShift'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

/** Remove camera and set previous camera to current camera */
export function* destroyCamera(action) {
  try {
    const { cameraIds, cameras } = yield select(destroyCameraSelector)
    const { id } = action
    const idToSwitchTo = chooseProperCameraToShift({ cameraIds, id })
    const mapCamera = findById({ state: cameras, id })

    yield put(removeDeviceWiresAction(id, 'camera'))
    yield call(mapCamera.remove)
    yield put(removeCameraAction(id, idToSwitchTo))
    if (cameras.length > 1) yield put(updatePresentationValuesAction())
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for destroy camera action, then call function */
export function* watchDestroyCamera() {
  yield* takeEvery(DESTROY_CAMERA, destroyCamera)
}



// WEBPACK FOOTER //
// ./src/sagas/destroyCameraSaga.js